import type { ReactNode } from 'react';

import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  readonly title: string;
  /** What to do about it. An empty state that only says "nothing here" wastes the moment. */
  readonly body?: string;
  readonly action?: ReactNode;
}

/**
 * Nothing to show, said usefully (STD-002 §3.4). The first ledger a person opens is empty, so this is one
 * of the first things anyone sees - it names the next step rather than reporting an absence.
 */
export function EmptyState({ title, body, action }: EmptyStateProps): React.JSX.Element {
  return (
    <div className={styles.empty}>
      <p className={styles.title}>{title}</p>
      {body ? <p className={styles.body}>{body}</p> : null}
      {action}
    </div>
  );
}
